import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Button } from '@vnetwork/ui/primitives';
import { RacksListSection } from './racks-list-section';

/**
 * Racks master list — a `PageHeader` over the server-paginated
 * `RacksListSection` (status filter + search over the legacy warehouse grid:
 * name/code/location/status/height/power/bandwidth/description). Rows link to
 * the rack detail route. Read-only (W3 scope).
 */
export default function CapacityRacksPage() {
  const navigate = useNavigate();

  return (
    <Container size="full">
      <PageHeader
        title="Racks"
        description="Datacenter racks and their mounted equipment."
        style={{ marginBottom: 'var(--vn-space-4)' }}
        actions={
          <Button startIcon={<Plus size={15} />} onClick={() => navigate('/capacities/racks/new')}>
            New rack
          </Button>
        }
      />

      <RacksListSection onRowClick={(r) => navigate(`/capacities/racks/${r.id}`)} />
    </Container>
  );
}
